module.exports = __webpack_public_path__ + "static/img/h6-6.75e7d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-6.png
// module id = DSjB
// module chunks = 1